export default "__VITE_ASSET__BXHrVcEH__"